import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

import { TIPTAP_FIGURE_TYPE } from './../../ricos-content';
import { createRicosFunctionalExtension } from './../../plugin-commons';

export const breakout = createRicosFunctionalExtension({
  type: 'extension',
  groups: [],
  name: 'breakout',
  reconfigure(config, _extensions, ricosProps, _settings, services) {
    const breakoutRule = ricosProps.breakoutRule;
    return {
      ...config,
      ...(breakoutRule && {
        addProseMirrorPlugins() {
          return [
            new Plugin({
              key: new PluginKey('breakout'),
              props: {
                decorations(state) {
                  const decorations: Decoration[] = [];
                  // Typically breakouts apply only for root nodes, so we use 'forEach' instead of 'descendants'
                  state.doc.forEach((node, pos) => {
                    const ricosNode = services.converters.fromPmNode(node.toJSON());
                    if (!ricosNode) {
                      return;
                    }

                    const breakoutType = breakoutRule({
                      node: ricosNode,
                    });

                    // Here is the exception where breakout applies not only to the root node (FIGURE),
                    // but also to the descendant (IMAGE|VIDEO) node.
                    // This is made in order to override Resizer HOC width which is applied on IMAGE container.
                    if (breakoutType === 'fullWidth' && node.type.name === TIPTAP_FIGURE_TYPE) {
                      node.descendants((childNode, childPos) => {
                        if (childNode.type.spec.group?.includes('figureFirstChildContent')) {
                          const childPosInDoc = childPos + pos + 1;
                          decorations.push(
                            Decoration.node(childPosInDoc, childPosInDoc + childNode.nodeSize, {
                              'data-breakout': breakoutType,
                            })
                          );
                        }
                      });
                    }

                    decorations.push(
                      Decoration.node(pos, pos + node.nodeSize, { 'data-breakout': breakoutType })
                    );
                  });
                  return DecorationSet.create(state.doc, decorations);
                },
              },
            }),
          ];
        },
      }),
    };
  },
  createExtensionConfig() {
    return {
      name: this.name,
      priority: 3,
    };
  },
});
